import stripe from './stripe';

export default {
    stripe,
};
